import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Icons } from '../../../constants/icons.constants';

@Component({
    selector: 'page-header',
    styleUrls: ['./page-header.component.scss'],
    template: `
        <div
            class="page-header-container container-fluid page-container"
            [class.short-bottom-padding]="shortBottomPadding"
        >
            <div class="left-content">
                <div class="back-button">
                    <lsq-button
                        *ngIf="!!backButtonText"
                        id="page-header-back-button"
                        appearance="transparent"
                        (buttonClick)="handleBackButtonClick.emit()"
                    >
                        <lsq-icon [type]="icons.ChevronLeft"></lsq-icon>
                        {{ backButtonText }}
                    </lsq-button>
                </div>
                <h1><lsq-smart-truncate [value]="titleText"></lsq-smart-truncate></h1>
                <ng-content select="[left-content]"></ng-content>
            </div>
            <div class="right-content">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    encapsulation: ViewEncapsulation.None
})
export class PageHeaderComponent {
    @Input() public titleText? = '';
    @Input() public backButtonText: string;
    @Input() public shortBottomPadding = false;
    @Output() public handleBackButtonClick = new EventEmitter();

    public readonly icons = Icons;
}
